<template>
    <div
        ref="googleBtn"
        :class="{
            [$style.small_button]: props.size === 's',
            [$style.large_button]: props.size === 'l',
        }"
    />
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { onMounted, ref, watch } from 'vue'

import { useGoogleAuthStore } from '@/store/google-auth-store'
import { useLoggerStore } from '@/store/logger'

const props = defineProps<{
    onFinish: (isSuccess: boolean) => void
    size: 's' | 'l'
}>()

const loggerStore = useLoggerStore()
const googleAuthStore = useGoogleAuthStore()
const { initialized } = storeToRefs(googleAuthStore)

const googleBtn = ref<HTMLElement>()

const initSignIn = () => {
    if (!window.google || !googleBtn.value) {
        return
    }

    window.google.accounts.id.renderButton(googleBtn.value, {
        type: 'standard',
        text: 'signin_with',
        theme: 'outline',
        shape: 'pill',
        size: 'large',
        logo_alignment: 'left',
        width: props.size === 's' ? 292 : 320,
        state: JSON.stringify({ returnURL: window.location.href }),
        click_listener: onClickHandler,
    })
}

function onClickHandler() {
    loggerStore.logInterfaceEvents({
        eventName: 'interface_click',
        interface_target: 'google-sign-in-button',
    })
    googleAuthStore.setOnFinishCallback(props.onFinish)
}

watch(initialized, initSignIn)
onMounted(() => {
    if (initialized.value) {
        initSignIn()
    }
})
</script>
<style module>
.small_button,
.large_button {
    color-scheme: light;
    height: 44px;
    overflow: hidden;
}

/*
    Using transform because the button is inside an iframe and can't be styled directly;
    fixed height prevents jumping when the user's photo loads
*/
.small_button {
    transform: scale(0.85);
    transform-origin: left center;
    width: 292px;
}

.large_button {
    transform: scale(1.1) translateY(2px);
    transform-origin: left center;
}
</style>
